module.exports = __webpack_public_path__ + "img/chat-speech-bubble.57774acc.svg";